export const STEPS = [
  { path: 'monthly-retirement-income', label: 'Monthly retirement income' },
  { path: 'retirement-age', label: 'Retirement age' },
  { path: 'social-security', label: 'Social Security' },
  { path: 'contributions', label: 'Contributions' },
  { path: 'goals', label: 'Goals' },
  { path: 'company-stock', label: 'Company stock' },
  { path: 'investments', label: 'Investments' },
  { path: 'summary', label: 'Summary' },
]

export const FIRST_STEP_PATH = STEPS[0].path

export const SSI_STEP_PATH = 'social-security'
export const GOALS_STEP_PATH = 'goals'
export const COMPANY_STOCK_STEP_PATH = 'company-stock'
export const INVESTMENTS_STEP_PATH = 'investments'
export const SUMMARY_STEP_PATH = 'summary'

export const TOTAL_STEPS = STEPS.length
